export const COOKIE_NAME = `_part`;
export const COOKIE_SECURED = `self-care`;
export const COOKIE_PUBLIC = `public`;
export const GA_PAGEVIEW = `gaPageview`;
// GA4 pageviews use a different event name (see enhancePageview in global.ts)
export const GA4_PAGEVIEW = `pageview`;
export const GA_EVENT = `gaEvent`;
